import {
    appCreateTokenSuccess,
    appGetTokenInfoSuccess,
    appNoOp,
  } from '@actions/app.action';
  import { Injectable, inject } from '@angular/core';
  import { Actions, createEffect, ofType } from '@ngrx/effects';
  import { Action, Store } from '@ngrx/store';
  import { concatLatestFrom } from '@ngrx/operators';
  import { ApoService as ApoHttpService } from '@services/api-clients/apo.service';
  import { catchError, map, mergeMap, Observable, of, tap } from 'rxjs';
  import { ApoService } from '@services/apo/apo.service';
  import { growthbookFeatureLoaded } from '@actions/growthbook.action';
  import { selectApo } from '@selectors/apo.selector';
  
  @Injectable()
  export class ApoEffect {
    private actions$ = inject(Actions);
    private apoHttpService = inject(ApoHttpService);
    private apoService = inject(ApoService);
    private store = inject(Store);
  
    addApos$ = createEffect(
      () => {
        return this.actions$.pipe(
          ofType(growthbookFeatureLoaded, appCreateTokenSuccess),
          tap(() => this.apoService.addApos()),
        );
      },
      {
        dispatch: false,
      },
    );
  
    saveApo$: Observable<Action> = createEffect(() => {
      return this.actions$.pipe(
        ofType(appGetTokenInfoSuccess),
        concatLatestFrom(() => this.store.select(selectApo)),
        mergeMap(([, apoFeatures]: [unknown, Record<string, string>]) =>
          this.apoHttpService.updateApo(apoFeatures).pipe(
            map(() => appNoOp()),
            catchError(() => of(appNoOp())),
          ),
        ),
      );
    });
  }
  